// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.bs.js");

var nbsp = String.fromCharCode(160);

var circleChar = String.fromCharCode(9679);

function currTimeStr(param) {
  return new Date(Date.now()).toISOString();
}

function compareDates(a, b) {
  var t1 = a.getTime();
  var t2 = b.getTime();
  if (t1 < t2) {
    return -1;
  } else if (t2 < t1) {
    return 1;
  } else {
    return 0;
  }
}

function floatToPctStr(pct) {
  return String(Math.round(pct * 100) | 0) + "%";
}

function cacheMake(recalc, depVerEq) {
  return {
          recalc: recalc,
          depVerEq: depVerEq,
          depVer: undefined,
          data: undefined
        };
}

function cacheGetByDepVer(cache, depVer) {
  var cachedDepVer = cache.depVer;
  if (cachedDepVer !== undefined && Curry._2(cache.depVerEq, Caml_option.valFromOption(cachedDepVer), depVer)) {
    return cache.data;
  }
  
}

function cacheGet(cache, depVer, dep) {
  var data = cacheGetByDepVer(cache, depVer);
  if (data !== undefined) {
    return Caml_option.valFromOption(data);
  }
  cache.depVer = Caml_option.some(depVer);
  var data$1 = Curry._1(cache.recalc, dep);
  cache.data = Caml_option.some(data$1);
  return data$1;
}

function strToRegex(str) {
  try {
    return {
            TAG: /* Ok */0,
            _0: new RegExp(str)
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    return {
            TAG: /* Error */1,
            _0: Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(exn), (function (prim) {
                        return prim.message;
                      })), "could not create a regular expression from string '" + str + "'")
          };
  }
}

function splitByRegex(str, regex) {
  return str.split(regex).map(function (strOpt) {
                return Belt_Option.getWithDefault(strOpt, "").trim();
              }).filter(function (str) {
              return str.length > 0;
            });
}

var newLineRegex = /[\n\r]/;

function multilineTextToNonEmptyLines(__x) {
  return splitByRegex(__x, newLineRegex);
}

var whitespaceDelimRegex = /[\s\n\r]/;

function getSpaceSeparatedValuesAsArray(__x) {
  return splitByRegex(__x, whitespaceDelimRegex);
}

var plusSignRegex = /\+/g;

var minusSignRegex = /-/g;

var forwardSlashSignRegex = /\//g;

var underscoreSignRegex = /_/g;

function strToSafeBase64(str) {
  return btoa(str).replace(plusSignRegex, "-").replace(forwardSlashSignRegex, "_");
}

function safeBase64ToStr(safeBase64) {
  return atob(safeBase64.replace(underscoreSignRegex, "/").replace(minusSignRegex, "+"));
}

function versionMake(val) {
  return {
          ver: 0,
          val: val
        };
}

function versionSet(version, newVal) {
  return {
          ver: version.ver + 1 | 0,
          val: newVal
        };
}

function arrayQueueMake(initSize) {
  var data = new Array(initSize);
  return {
          begin: 0,
          end: -1,
          maxEnd: data.length - 1 | 0,
          data: data
        };
}

function arrayQueueAdd(q, elem) {
  if (q.end === q.maxEnd) {
    console.log("q.end == q.maxEnd");
    q.data = Belt_Array.concat(q.data, new Array(q.data.length));
    q.maxEnd = q.data.length - 1 | 0;
  }
  q.end = q.end + 1 | 0;
  Caml_array.set(q.data, q.end, elem);
}

function arrayQueuePop(q) {
  if (q.begin > q.end) {
    return ;
  }
  var res = Caml_array.get(q.data, q.begin);
  q.begin = q.begin + 1 | 0;
  return Caml_option.some(res);
}

function arrayQueueReset(q) {
  q.begin = 0;
  q.end = -1;
}

function createVarTypeComparator(varTypes, typeOrder) {
  var varOrderByType = Belt_HashMapInt.make(Belt_HashMapInt.size(varTypes));
  Belt_HashMapInt.forEach(varTypes, (function ($$var, typ) {
          var tOrder = Belt_HashMapInt.get(typeOrder, typ);
          if (tOrder !== undefined) {
            return Belt_HashMapInt.set(varOrderByType, $$var, tOrder);
          }
          
        }));
  return function (a, b) {
    var aTypOrder = Belt_HashMapInt.get(varOrderByType, a);
    if (aTypOrder !== undefined) {
      var bTypOrder = Belt_HashMapInt.get(varOrderByType, b);
      if (bTypOrder !== undefined) {
        return Expln_utils_common.intCmp(aTypOrder, bTypOrder);
      } else {
        return -1;
      }
    }
    var match = Belt_HashMapInt.get(varOrderByType, b);
    if (match !== undefined) {
      return 1;
    } else {
      return 0;
    }
  };
}

function createVarNameComparator(varNames, a, b) {
  var aStr = Belt_HashMapInt.get(varNames, a);
  if (aStr !== undefined) {
    var bStr = Belt_HashMapInt.get(varNames, b);
    if (bStr !== undefined) {
      return aStr.localeCompare(bStr) | 0;
    } else {
      return -1;
    }
  }
  var match = Belt_HashMapInt.get(varNames, b);
  if (match !== undefined) {
    return 1;
  } else {
    return 0;
  }
}

function createTypeOrderFromStr(sortDisjByType, typeNameToInt) {
  var typeOrderInDisj = Belt_HashMapInt.make(4);
  getSpaceSeparatedValuesAsArray(sortDisjByType).forEach(function (typStr) {
        var i = Curry._1(typeNameToInt, typStr);
        if (i !== undefined) {
          return Belt_HashMapInt.set(typeOrderInDisj, i, Belt_HashMapInt.size(typeOrderInDisj));
        }
        
      });
  return typeOrderInDisj;
}

function strToBase64(prim) {
  return btoa(prim);
}

function base64ToStr(prim) {
  return atob(prim);
}

function $$setTimeout$1(prim0, prim1) {
  return setTimeout(prim0, prim1);
}

function $$clearTimeout$1(prim) {
  clearTimeout(prim);
}

var stubTimeoutId = 0;

exports.nbsp = nbsp;
exports.circleChar = circleChar;
exports.currTimeStr = currTimeStr;
exports.compareDates = compareDates;
exports.floatToPctStr = floatToPctStr;
exports.cacheMake = cacheMake;
exports.cacheGetByDepVer = cacheGetByDepVer;
exports.cacheGet = cacheGet;
exports.multilineTextToNonEmptyLines = multilineTextToNonEmptyLines;
exports.getSpaceSeparatedValuesAsArray = getSpaceSeparatedValuesAsArray;
exports.strToBase64 = strToBase64;
exports.base64ToStr = base64ToStr;
exports.strToSafeBase64 = strToSafeBase64;
exports.safeBase64ToStr = safeBase64ToStr;
exports.strToRegex = strToRegex;
exports.$$setTimeout = $$setTimeout$1;
exports.$$clearTimeout = $$clearTimeout$1;
exports.stubTimeoutId = stubTimeoutId;
exports.versionMake = versionMake;
exports.versionSet = versionSet;
exports.arrayQueueMake = arrayQueueMake;
exports.arrayQueueAdd = arrayQueueAdd;
exports.arrayQueuePop = arrayQueuePop;
exports.arrayQueueReset = arrayQueueReset;
exports.createVarTypeComparator = createVarTypeComparator;
exports.createVarNameComparator = createVarNameComparator;
exports.createTypeOrderFromStr = createTypeOrderFromStr;
/* nbsp Not a pure module */
